<template lang="html">
  <div class="edit-wrapper">
    <div class="tabs">
      <!-- <span :class="{ active : active === 'editBlog' }" @click="active = 'editBlog'">Blog</span> -->
      <h2>{{ $t('admin.create.editBlog') }}</h2>
    </div>
    <keep-alive>
      <component :is="getActiveComponent" />
    </keep-alive>
  </div>
</template>

<script>
import editBlog from '@/components/admin/editBlog.vue'
export default {
  name: 'Edit',
  components: {
    editBlog,
  },
  data () {
    return {
      active: 'editBlog'
    }
  },
  computed: {
    getActiveComponent () {
      return this.active
    }
  }
}
</script>

<style lang="scss" scoped>
.edit-wrapper {
  text-align: left;
  .tabs {
    margin-bottom: 20px;
    span {
      margin-right: 20px;
      cursor: pointer;
    }
    span:last-child {
      margin-right: 0px;
    }
    span.active {
      color: var(--main-color);
    }
  }
}
</style>
